import {
  DublicateClientsHeader,
  DublicateClientsPage,
} from '@pages/DublicateClients/ui';

export const DublicateClients = {
  Page: DublicateClientsPage,
  Header: DublicateClientsHeader,
};
